type TContentProps = {
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export default function Content({
  children,
  className,
  ...props
}: TContentProps) {
  return (
    <>
      <style jsx>{`
        .content-wrapper {
          padding: 0 6px;
        }
      `}</style>
      <div
        className={`content-wrapper mx-auto overflow-auto max-w-[680px] ${
          className ?? ''
        }`}
        {...props}
      >
        {children}
      </div>
    </>
  );
}
